import { types as t, } from 'mobx-state-tree';
import Field from './Field'

const Definition = t.model("Definition", {
	//Guid: t.identifier,
	Id: t.identifier,
	Name: t.string,
	Fields: t.array(Field)
}).views(self => ({
    get DisplayFields() {
        return self.Fields.filter(x => x.DisplayOnWebSite);
    }
})).actions(self => ({ 

}));

export default Definition;